import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to the top on every route change so users always land
// at the top of the next page instead of at their previous scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser-native scroll restoration once so it can't fight the
  // useEffect below on back/forward nav.
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // Reset immediately, then again after the next paint so any post-mount
    // layout shift (banners, lazy content) can't leave the page a few dozen
    // pixels short of the top.
    const scroll = () => window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    scroll();
    const raf = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
}
